import BaseDecorator from "./BaseDecorator";
import ProductDecorator from "./ProductDecorator";
import ProductPricelistItemDecorator from "./ProductPricelistItemDecorator";

export default class AgentDealPricingDecorator extends BaseDecorator {
  transformData(data) {
    return super.transformData({
      ...data,
      product: data.product && new ProductDecorator(data.product),
      product_pricelist_item:
        data.product_pricelist_item && new ProductPricelistItemDecorator(data.product_pricelist_item),
    });
  }

  get is_default_pricing() {
    return !this.product && !this.product_pricelist_item;
  }

  get price_relative_amount_or_percentage() {
    if (this.price_relative_amount !== null) {
      return this.price_relative_amount;
    } else if (this.price_relative_percentage !== null) {
      return {
        value: this.price_relative_percentage,
        currency: "percentage",
      };
    } else {
      return null;
    }
  }

  set price_relative_amount_or_percentage(price_relative_amount_or_percentage) {
    if (!price_relative_amount_or_percentage) {
      this.price_relative_amount = null;
      this.price_relative_percentage = null;
    } else if (price_relative_amount_or_percentage.currency === "percentage") {
      this.price_relative_amount = null;
      this.price_relative_percentage = price_relative_amount_or_percentage.value;
    } else {
      this.price_relative_amount = price_relative_amount_or_percentage;
      this.price_relative_percentage = null;
    }
  }

  get commision_absolute_amount_or_percentage() {
    if (this.commision_absolute_amount !== null) {
      return this.commision_absolute_amount;
    } else if (this.commision_absolute_percentage !== null) {
      return {
        value: this.commision_absolute_percentage,
        currency: "percentage",
      };
    } else {
      return null;
    }
  }

  set commision_absolute_amount_or_percentage(commision_absolute_amount_or_percentage) {
    if (!commision_absolute_amount_or_percentage) {
      this.commision_absolute_amount = null;
      this.commision_absolute_percentage = null;
    } else if (commision_absolute_amount_or_percentage.currency === "percentage") {
      this.commision_absolute_amount = null;
      this.commision_absolute_percentage = commision_absolute_amount_or_percentage.value;
    } else {
      this.commision_absolute_amount = commision_absolute_amount_or_percentage;
      this.commision_absolute_percentage = null;
    }
  }

  get service_fee_absolute_amount_or_percentage() {
    if (this.service_fee_absolute_amount !== null) {
      return this.service_fee_absolute_amount;
    } else if (this.service_fee_absolute_percentage !== null) {
      return {
        value: this.service_fee_absolute_percentage,
        currency: "percentage",
      };
    } else {
      return null;
    }
  }

  set service_fee_absolute_amount_or_percentage(service_fee_absolute_amount_or_percentage) {
    if (!service_fee_absolute_amount_or_percentage) {
      this.service_fee_absolute_amount = null;
      this.service_fee_absolute_percentage = null;
    } else if (service_fee_absolute_amount_or_percentage.currency === "percentage") {
      this.service_fee_absolute_amount = null;
      this.service_fee_absolute_percentage = service_fee_absolute_amount_or_percentage.value;
    } else {
      this.service_fee_absolute_amount = service_fee_absolute_amount_or_percentage;
      this.service_fee_absolute_percentage = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/AgentDealPricingDecorator.js